export class Duration {
    private constructor(public milliseconds: number) {}

    public static zero(): Duration {
        return new Duration(0);
    }

    public get seconds(): number {
        return this.milliseconds / 1000;
    }

    public get minutes(): number {
        return this.seconds / 60;
    }

    public get hours(): number {
        return this.minutes / 60;
    }

    public static fromMilliseconds(milliseconds: number): Duration {
        return new Duration(milliseconds);
    }

    public static fromSeconds(seconds: number): Duration {
        return new Duration(seconds * 1000);
    }

    public static fromMinutes(minutes: number): Duration {
        return new Duration(minutes * 60 * 1000);
    }

    public static fromHours(hours: number): Duration {
        return new Duration(hours * 60 * 60 * 1000);
    }

    public add(other: Duration): Duration {
        return new Duration(this.milliseconds + other.milliseconds);
    }

    public subtract(other: Duration): Duration {
        return new Duration(this.milliseconds - other.milliseconds);
    }

    public equals(other: Duration): boolean {
        return this.milliseconds === other.milliseconds;
    }

    public gt(duration: Duration) {
        return this.milliseconds > duration.milliseconds;
    }

    public gte(duration: Duration) {
        return this.milliseconds >= duration.milliseconds;
    }

    public lte(duration: Duration) {
        return this.milliseconds <= duration.milliseconds;
    }
    public lt(duration: Duration) {
        return this.milliseconds < duration.milliseconds;
    }

    static average(...durations: Duration[]): Duration | null {
        if (durations.length === 0) {
            return null;
        }
        const totalMilliseconds = durations.reduce((total, duration) => total + duration.milliseconds, 0);
        return Duration.fromMilliseconds(totalMilliseconds / durations.length);
    }
}
